import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedUiEmailModule } from '@se-po/shared-ui-email'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeChipModule } from 'se-fe-chip'
import {
  SeFeIconModule,
  seFeIconSpotCopy,
  seFeIconSpotInviteSuccess,
  seFeIconSpotSafety,
  seFeIconSpotSandClock,
  seFeIconSpotWhistle,
} from 'se-fe-icon'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { MinorAccountAcceptComponent } from './minor-account-accept/minor-account-accept.component'
import { MinorAccountInviteSentComponent } from './minor-account-invite-sent/minor-account-invite-sent.component'
import { MinorAccountInviteComponent } from './minor-account-invite/minor-account-invite.component'
import { MinorAccountNotFoundComponent } from './minor-account-not-found/minor-account-not-found.component'
import { MinorAccountRepeatComponent } from './minor-account-repeat/minor-account-repeat.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeChipModule,
    SeFeMenuModule,
    SeFeSpinnerModule,
    SeFeIconModule.include([
      seFeIconSpotCopy,
      seFeIconSpotInviteSuccess,
      seFeIconSpotSafety,
      seFeIconSpotSandClock,
      seFeIconSpotWhistle,
    ]),
    SharedUiEmailModule,
    SharedUiHighlightLabelModule,
  ],
  declarations: [
    MinorAccountAcceptComponent,
    MinorAccountInviteComponent,
    MinorAccountInviteSentComponent,
    MinorAccountNotFoundComponent,
    MinorAccountRepeatComponent,
  ],
  exports: [
    MinorAccountAcceptComponent,
    MinorAccountInviteComponent,
    MinorAccountInviteSentComponent,
    MinorAccountNotFoundComponent,
    MinorAccountRepeatComponent,
  ],
  providers: [
    { provide: Window, useValue: window },
  ],
})
export class SeHouseholdSetupFeatureMinorAccountInviteModule {}
